import React, { useContext } from 'react';
import { AccountContext } from '../AccountContext';
import { useAccountById } from '@app/sdk';
import { LoadingWrapper } from '../../tms/components/LoadingWrapper';
import { List } from 'semantic-ui-react';
import { Item } from '../../../shared/Item';
import { toCurrency, toFormattedDate } from '@app/utilities';
import ProductDetails from './ProductDetails';
import { creditLimitIncreasePreferenceOptions } from '../constants/credit-limit-increase-preference-options';

export function AccountBrief() {
  const { accountId } = useContext(AccountContext);
  const { data: account, isLoading } = useAccountById(accountId);
  return (
    <div className="ui card">
      <LoadingWrapper loading={isLoading}>
        {account && (
          <>
            <div className="custom-card-header">Account: {account.accountNumber}</div>
            <div className="content">
              <List>
                <Item header={'Status:'} description={account.accountStatus.name} />
                  {account.accountStatus.accountStatusUpdateReason && (
                      <Item header={'Status Reason:'} description={account.accountStatus.accountStatusUpdateReason} />
                  )}
                <Item header={'Credit Limit:'} description={toCurrency(account.creditLimit)} />
                <Item header={'Credit Limit Increase Preference:'} description={creditLimitIncreasePreferenceOptions.find(item => item.value === account.creditLimitIncreasePreference)?.label} />
                <Item header={'Created Date:'} description={toFormattedDate(account.createdDate)} />
                <Item header={'Statement Day:'} description={account.statementDay} />
                {account.paymentDay && <Item header={'Payment Day:'} description={account.paymentDay} />}
                <Item header={'Statement Type:'} description={account.statementType} />
                <ProductDetails />
              </List>
            </div>
          </>
        )}
      </LoadingWrapper>
    </div>
  );
}
